/* ==========================================================
 * ES QuickView -> LensAdvisor bridge (SAFE)
 *
 * Problem:
 * - Some products are LensAdvisor-managed on PDP (CTA becomes SELECT LENSES).
 * - QuickView still shows ADD TO CART and actually adds to cart, allowing users
 *   to bypass the lens selection flow.
 *
 * Solution:
 * - We mark QuickView triggers with data-es-la="1" in product cards.
 * - When QuickView opens, if the last trigger was LA-managed, we:
 *   - Change the QuickView CTA label to SELECT LENSES (only when the button is enabled)
 *   - Intercept clicks and redirect to PDP with ?openLA=1
 *
 * IMPORTANT:
 * - No global MutationObserver (that can freeze the page).
 * - We only re-apply on known events (qv-loaded + option changes).
 * ========================================================== */

(function(){
  'use strict';

  function getSelectLensesText(){
    if (window.ES_I18N && window.ES_I18N.select_lenses) return window.ES_I18N.select_lenses;
    var loc = (window.Shopify && Shopify.locale) || document.documentElement.getAttribute('lang') || '';
    if ((loc || '').toLowerCase().indexOf('de') === 0) return 'Gläser auswählen';
    return 'SELECT LENSES';
  }
  function getSelectLensesAria(){
    if (window.ES_I18N && window.ES_I18N.select_lenses_aria) return window.ES_I18N.select_lenses_aria;
    var loc = (window.Shopify && Shopify.locale) || document.documentElement.getAttribute('lang') || '';
    if ((loc || '').toLowerCase().indexOf('de') === 0) return 'Gläser auswählen';
    return 'Select lenses';
  }

  function setSelectLensesVisual($btn){
    if (!$btn || !$btn.length) return;
    var txt = getSelectLensesText();
    // For themes that override text via CSS ::after, set data attribute for localization
    try { $btn.attr('data-es-qv-label', txt); } catch(e){}
    // Also set actual text as a fallback (in case CSS override is removed)
    try { $btn.text(txt); } catch(e){}
    // aria label
    try { $btn.attr('aria-label', getSelectLensesAria()); } catch(e){}
  }




  var STATE = {
    isLA: false,
    lastHref: '',
    qvHandle: ''
  };

  /* ==========================================================
   * ES PREFERRED NAV — Make QuickView a real browser history state
   *
   * Goal:
   * - When user comes back from PDP, a single Back should restore the exact screen
   *   before clicking SELECT LENSES (the QuickView modal).
   *
   * Approach:
   * - When QuickView opens, pushState and add #qv=<handle> to the URL.
   * - When user navigates Back to that URL, we auto-open QuickView from the hash.
   * - When user leaves QuickView (close overlay), we remove the hash *without*
   *   hijacking Back to another page.
   *
   * Result:
   * - Navigation feels native (Back/Forward works as expected).
   * ========================================================== */
  var ES_QV_HISTORY = false; // disabled: do not reopen QuickView on Back
  // If a previous version left #qv=... in the URL, remove it to keep Back behavior native
  // and avoid reopening QuickView automatically.
  (function cleanupLegacyQvHash(){
    try {
      var h = (window.location.hash || '');
      if (!h) return;
      // Only clean hashes that look like our QuickView state.
      if (/#(?:.*\b)?qv=/.test(h) || /#(?:.*\b)?vid=/.test(h)) {
        window.history.replaceState(window.history.state || {}, '', (window.location.pathname || '') + (window.location.search || ''));
      }
    } catch(e) {}
  })();

  // Restore scroll position when returning to the originating list/search page.
  // QuickView often locks page scroll using body{position:fixed; top:-Y}px; in that case window.scrollY=0.
  // We re-apply for a short window to beat late layout shifts (lazy images / grid scripts).
  (function restoreOriginScroll(){
    try {
      var origin = sessionStorage.getItem('es_la_origin_url');
      if (!origin) return;

      var ts = parseInt(sessionStorage.getItem('es_la_origin_ts') || '0', 10);
      // Safety: expire after 30 minutes to avoid surprising jumps.
      if (ts && (Date.now() - ts) > 30 * 60 * 1000) {
        sessionStorage.removeItem('es_la_origin_url');
        sessionStorage.removeItem('es_la_origin_y');
        sessionStorage.removeItem('es_la_origin_ts');
        sessionStorage.removeItem('es_qv_open_url');
        sessionStorage.removeItem('es_qv_open_y');
        sessionStorage.removeItem('es_qv_open_ts');
        return;
      }

      var here = (window.location.href || '').split('#')[0];
      var want = String(origin).split('#')[0];
      if (here !== want) return;

      var y = parseInt(sessionStorage.getItem('es_la_origin_y') || '0', 10);
      if (isNaN(y) || y < 1) y = 0;

      var cleaned = false;
      function cleanup(){
        if (cleaned) return;
        cleaned = true;
        try {
          sessionStorage.removeItem('es_la_origin_url');
          sessionStorage.removeItem('es_la_origin_y');
          sessionStorage.removeItem('es_la_origin_ts');
          sessionStorage.removeItem('es_qv_open_url');
          sessionStorage.removeItem('es_qv_open_y');
          sessionStorage.removeItem('es_qv_open_ts');
        } catch(e) {}
      }

      function scrollMax(){
        try {
          var doc = document.documentElement;
          return Math.max(0, (doc.scrollHeight || 0) - (window.innerHeight || 0));
        } catch(e) { return 0; }
      }

      var running = false;
      function applyScroll(){
        if (cleaned || running) return;
        running = true;

        if (!y) { cleanup(); return; }

        try { if ('scrollRestoration' in history) history.scrollRestoration = 'manual'; } catch(e) {}

        var start = Date.now();
        var maxMs = 2600;

        (function tick(){
          if (cleaned) return;

          var maxS = scrollMax();
          // If page isn't tall enough yet, wait and keep trying.
          var target = (maxS >= (y - 5)) ? Math.min(y, maxS) : maxS;

          try { window.scrollTo(0, target); } catch(e) {}

          var cur = 0;
          try { cur = window.scrollY || window.pageYOffset || document.documentElement.scrollTop || 0; } catch(e2) {}

          if (maxS >= (y - 5) && Math.abs(cur - target) < 3) {
            cleanup();
            return;
          }
          if ((Date.now() - start) > maxMs) {
            cleanup();
            return;
          }
          requestAnimationFrame(tick);
        })();

        // Extra re-apply after late layout shifts.
        setTimeout(function(){ if (!cleaned) { try { window.scrollTo(0, Math.min(y, scrollMax())); } catch(e){} } }, 250);
        setTimeout(function(){ if (!cleaned) { try { window.scrollTo(0, Math.min(y, scrollMax())); } catch(e){} } }, 750);
        setTimeout(function(){ if (!cleaned) { try { window.scrollTo(0, Math.min(y, scrollMax())); } catch(e){} } }, 1400);
      }

      // Run ASAP and also on pageshow/load (covers bfcache + normal loads).
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', applyScroll, { once: true });
      } else {
        applyScroll();
      }
      window.addEventListener('pageshow', function(){ applyScroll(); }, { once: true });
      window.addEventListener('load', function(){ applyScroll(); }, { once: true });
    } catch(e) {}
  })();




  function baseUrlNoHash(){
    return (window.location.pathname || '') + (window.location.search || '');
  }

  function parseQvFromHash(){
    try {
      var h = (window.location.hash || '').replace(/^#/, '');
      if (!h) return null;
      var params = new URLSearchParams(h);
      var handle = params.get('qv') || '';
      if (!handle) return null;
      var vid = params.get('vid') || '';
      return { handle: decodeURIComponent(handle), variantId: vid ? decodeURIComponent(vid) : '' };
    } catch(e) {
      try {
        var hh = (window.location.hash || '').replace(/^#/, '');
        var m = hh.match(/(?:^|&)qv=([^&]+)/);
        if (!m) return null;
        var handle2 = decodeURIComponent(m[1]);
        var m2 = hh.match(/(?:^|&)vid=([^&]+)/);
        return { handle: handle2, variantId: m2 ? decodeURIComponent(m2[1]) : '' };
      } catch(e2) {}
    }
    return null;
  }

  function buildQvHash(handle, variantId){
    if (!handle) return '';
    var s = 'qv=' + encodeURIComponent(handle);
    if (variantId) s += '&vid=' + encodeURIComponent(variantId);
    return s;
  }

  function isQuickviewOpen(){
    try {
      var qv = document.querySelector('.quickview-product');
      return !!(qv && qv.classList.contains('active'));
    } catch(e) { return false; }
  }

  function closeQuickviewSafe(){
    try {
      if (typeof window.hidePopup === 'function') {
        window.hidePopup('.tshopify-popup');
        window.hidePopup('.quickview-product');
        return;
      }
    } catch(e) {}
    try {
      var qv = document.querySelector('.quickview-product');
      if (qv) qv.classList.remove('active');
      document.documentElement.classList.remove('es-qv-open');
      if (document.body) document.body.classList.remove('es-qv-open');
    } catch(e2) {}
  }

  function pushQuickviewState(handle){
    if (!ES_QV_HISTORY) return;
    if (!handle) return;
    try {
      if (window.innerWidth && window.innerWidth < 992) return; // theme disables quickview
    } catch(e) {}
    var vid = '';
    try { vid = getQuickviewVariantId() || ''; } catch(e2) { vid = ''; }
    var hash = buildQvHash(handle, vid);
    if (!hash) return;
    var url = baseUrlNoHash() + '#' + hash;
    // Avoid stacking duplicates if we're already in the same state.
    if ((window.location.hash || '') === ('#' + hash)) {
      try { window.history.replaceState({ es_qv: 1, handle: handle, variantId: vid, y: (window.scrollY || 0) }, '', url); } catch(e3) {}
      return;
    }
    try {
      window.history.pushState({ es_qv: 1, handle: handle, variantId: vid, y: (window.scrollY || 0) }, '', url);
    } catch(e4) {
      try { window.location.hash = hash; } catch(e5) {}
    }
  }

  function replaceQuickviewState(handle, variantId){
    if (!ES_QV_HISTORY) return;
    if (!handle) return;
    try {
      var hash = buildQvHash(handle, variantId || '');
      var url = baseUrlNoHash() + (hash ? ('#' + hash) : '');
      var prev = window.history.state || {};
      var next = {
        es_qv: 1,
        handle: handle,
        variantId: variantId || prev.variantId || '',
        y: (typeof prev.y === 'number' ? prev.y : (window.scrollY || 0))
      };
      window.history.replaceState(next, '', url);
    } catch(e) {}
  }

  function openQuickviewFromHashIfNeeded(){
    if (!ES_QV_HISTORY) return;
    var p = parseQvFromHash();
    if (!p || !p.handle) return;
    // If QuickView is already open, do nothing.
    if (isQuickviewOpen()) return;
    // Restore the exact pre-SELECT-LENSES screen.
    restoreQuickviewIfNeeded({ qvHandle: p.handle, qvVariantId: p.variantId });
  }

  function handleHistoryNavigation(){
    if (!ES_QV_HISTORY) return;
    var p = parseQvFromHash();
    if (p && p.handle) {
      setTimeout(openQuickviewFromHashIfNeeded, 0);
    } else {
      // If user went Back from the QV state, close the modal.
      setTimeout(closeQuickviewSafe, 0);
    }
  }

  // Open QV automatically when landing on a #qv state (Back/Forward, reload).
  if (ES_QV_HISTORY) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', function(){
        setTimeout(openQuickviewFromHashIfNeeded, 0);
      }, { once: true });
    } else {
      setTimeout(openQuickviewFromHashIfNeeded, 0);
    }
    window.addEventListener('pageshow', function(){
      setTimeout(openQuickviewFromHashIfNeeded, 0);
    });
    window.addEventListener('popstate', handleHistoryNavigation);

    // When user closes QuickView (overlay / close button), remove the #qv hash
    // WITHOUT navigating away unexpectedly.
    document.addEventListener('click', function(ev){
      var closer = closest(ev.target, '.overlay,.overlay-quickview,.continue-shopping,.close-window');
      if (!closer) return;
      if (!isQuickviewOpen()) return;
      var p = parseQvFromHash();
      if (!p || !p.handle) return;

      // Let theme close the modal first, then fix URL.
      setTimeout(function(){
        try {
          var st = window.history.state || {};
          if (st && st.es_qv) {
            // We created a dedicated QV history entry -> go back to the same page without #qv.
            window.history.back();
          } else {
            // Landed directly on #qv (no prior entry). Just clear the hash in-place.
            window.history.replaceState(st, '', baseUrlNoHash());
          }
        } catch(e) {
          try { window.location.hash = ''; } catch(e2) {}
        }
      }, 0);
    }, true);

    // Also handle programmatic closes (e.g. quickview add-to-cart success)
    // by wrapping hidePopup when available.
    (function wrapHidePopup(){
      var tries = 0;
      function attempt(){
        tries++;
        try {
          if (!window.hidePopup || window.hidePopup.__es_qv_wrapped) {
            if (tries < 30) return setTimeout(attempt, 200);
            return;
          }
          var orig = window.hidePopup;
          window.hidePopup = function(selector){
            var r;
            try { r = orig.apply(this, arguments); } catch(e) {}
            try {
              if (selector === '.quickview-product') {
                var p = parseQvFromHash();
                if (p && p.handle) {
                  setTimeout(function(){
                    try {
                      var st = window.history.state || {};
                      if (st && st.es_qv) window.history.back();
                      else window.history.replaceState(st, '', baseUrlNoHash());
                    } catch(e2) {}
                  }, 0);
                }
              }
            } catch(e3) {}
            return r;
          };
          window.hidePopup.__es_qv_wrapped = true;
        } catch(e4) {
          if (tries < 30) return setTimeout(attempt, 200);
        }
      }
      attempt();
    })();
  }

  function getHandleFromHref(href){
    if (!href) return '';
    try {
      var u = new URL(href, window.location.origin);
      var m = (u.pathname || '').match(/\/products\/([^\/\?#]+)/);
      return (m && m[1]) ? decodeURIComponent(m[1]) : '';
    } catch(e) {
      try {
        var p = (href || '').split('?')[0].split('#')[0];
        var mm = p.match(/\/products\/([^\/]+)/);
        return (mm && mm[1]) ? decodeURIComponent(mm[1]) : '';
      } catch(e2) {}
    }
    return '';
  }

  function getQuickviewVariantId(){
    try {
      var el = document.querySelector('.quickview-product select[name=id], .quickview-product input[name=id]');
      return el ? (el.value || '') : '';
    } catch(e) { return ''; }
  }

  // Legacy sessionStorage-based backfix removed in favor of history/hash.

  function restoreQuickviewIfNeeded(payload){
    try {
      if (!payload) return;
      var handle = payload.qvHandle;
      if (!handle) return;

      // Theme disables quickview under 992px; don't fight it.
      try {
        if (window.innerWidth && window.innerWidth < 992) return;
      } catch(e) {}

      var wantedVariantId = payload.qvVariantId || '';

      function setVariantWhenReady(){
        if (!wantedVariantId) return;
        var tries = 0;
        (function tick(){
          tries++;
          var root = document.querySelector('.quickview-product.active') || document.querySelector('.quickview-product');
          if (!root) {
            if (tries < 40) return setTimeout(tick, 200);
            return;
          }
          var sel = root.querySelector('select[name=id]');
          var inp = root.querySelector('input[name=id]');
          if (sel) {
            try {
              sel.value = wantedVariantId;
              sel.dispatchEvent(new Event('change', { bubbles: true }));
            } catch(e) {}
            return;
          }
          if (inp) {
            try { inp.value = wantedVariantId; } catch(e2) {}
            return;
          }
          if (tries < 40) return setTimeout(tick, 200);
        })();
      }

      // 1) Preferred: find the original quickview trigger on the page and click it.
      var attempts = 0;
      (function tryClickTrigger(){
        attempts++;
        var btn = null;
        try {
          btn = document.querySelector('.engoj_btn_quickview[data-id="' + CSS.escape(handle) + '"]');
        } catch(e) {
          // CSS.escape may be missing in older browsers; fallback selector
          btn = document.querySelector('.engoj_btn_quickview[data-id="' + handle.replace(/"/g, '\\"') + '"]');
        }
        if (btn) {
          try { btn.click(); } catch(e2) {
            try { btn.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window })); } catch(e3) {}
          }
          setTimeout(setVariantWhenReady, 250);
          return;
        }

        // 2) Fallback: open quickview even if the product card isn't present (pagination, etc.)
        if (attempts === 6) {
          try {
            if (window.Shopify && typeof window.Shopify.getProduct === 'function' && window.jQuery && window.tshopifyQuickview && typeof window.showPopup === 'function') {
              window.showPopup('.loading');
              window.Shopify.getProduct(handle, function(product){
                try {
                  var $ = window.jQuery;
                  var template = $('#quick-view').html();
                  $('.quickview-product').html(template);
                  var quickview = $('.quickview-product');
                  quickview.find('.product-name a').html(product.title).attr('href', product.url);
                  quickview.find('.spr-badge .spr-active').css({"width": "0%"});
                  quickview.find('.star-rating .shopify-product-reviews-badge').attr('data-id', product.id);

                  if (quickview.find('.des').length > 0) {
                    quickview.find('.des').html(product.description);
                  } else {
                    quickview.find('.des').remove();
                  }

                  quickview.find('.price').html(Shopify.formatMoney(product.price, window.money_format));
                  quickview.find('.product-inner').attr('id', 'product-' + product.id);
                  quickview.find('.variants').attr('id', 'product-actions-' + product.id);
                  quickview.find('.variants select').attr('id', 'product-select-' + product.id);

                  if (!product.available) {
                    quickview.find("select, input, .total-price, .dec, .inc, .variants label").remove();
                    quickview.find(".btn-addToCart").text('unavailable').addClass('disabled').attr("disabled", "disabled");
                  } else {
                    var p = product.price;
                    try {
                      if (typeof window.currencyConverter === 'function') p = window.currencyConverter(p);
                    } catch(e) {}
                    quickview.find('.total-price span').html(Shopify.formatMoney(p, window.money_format));
                    try { window.tshopifyQuickview.createQuickViewVariantsSwatch(product, quickview); } catch(e) {}
                  }
                  try { window.qtyProduct(); } catch(e) {}
                  try { window.tshopifyQuickview.quickViewSlider(product, quickview); } catch(e) {}
                  try { window.tshopifyQuickview.initQuickviewAddToCart(); } catch(e) {}

                  $('.quickview-product').addClass('active');
                  $('html,body').addClass('es-qv-open');
                  $('.loading').addClass('loaded-content');
                  window.hidePopup('.loading');

                  setTimeout(setVariantWhenReady, 250);
                } catch(e) {
                  try { window.hidePopup('.loading'); } catch(e2) {}
                }
              });
              return;
            }
          } catch(e) {}
        }

        if (attempts < 20) return setTimeout(tryClickTrigger, 200);
      })();
    } catch(e) {}
  }

  // (no scroll/quickview restore from storage)

  function q(sel, root){
    try { return (root || document).querySelector(sel); } catch(e){ return null; }
  }

  function closest(el, sel){
    try { return el && el.closest ? el.closest(sel) : null; } catch(e){ return null; }
  }

  function getBestScrollY(){
    var y = 0;
    try { y = (window.scrollY || window.pageYOffset || 0); } catch(e) {}
    if (y && y > 0) return y;
    try {
      var body = document.body;
      if (body) {
        var pos = '';
        try { pos = (body.style && body.style.position) || ''; } catch(e0) {}
        if (!pos) {
          try { pos = (window.getComputedStyle(body).position || ''); } catch(e1) {}
        }
        var topv = '';
        try { topv = (body.style && body.style.top) || ''; } catch(e2) {}
        if (pos === 'fixed' && topv) {
          var n = parseInt(topv, 10);
          if (!isNaN(n) && n !== 0) return Math.abs(n);
        }
      }
    } catch(e3) {}
    try { y = (document.documentElement.scrollTop || document.body.scrollTop || 0); } catch(e4) {}
    return y || 0;
  }

  function getProductHref(){
    // quickview.js always sets .product-name a href to product.url
    var a = q('.quickview-product .product-name a[href], .quickview-product .product-title a[href]');
    if (!a) return '';
    return (a.getAttribute('href') || '').trim();
  }

  // Build PDP URL that:
  //  - opens LensAdvisor automatically (?openLA=1)
  //  - preserves the currently selected variant in QuickView (?variant=<id>)
  // This prevents PDP from falling back to the first color/variant.
  function withOpenLA(href){
    if (!href) return '';
    var vid = '';
    try { vid = (getQuickviewVariantId() || '').trim(); } catch(e0) {}

    try {
      var u = new URL(href, window.location.origin);
      u.searchParams.set('openLA', '1');
      if (vid) u.searchParams.set('variant', vid);
      return u.toString();
    } catch(e){
      // Fallback for relative or malformed href
      var out = href;
      if (out.indexOf('openLA=1') === -1 && out.indexOf('openLA=true') === -1) {
        out += (out.indexOf('?') === -1 ? '?openLA=1' : '&openLA=1');
      }
      if (vid && out.indexOf('variant=') === -1) {
        out += (out.indexOf('?') === -1 ? '?variant=' + encodeURIComponent(vid) : '&variant=' + encodeURIComponent(vid));
      }
      return out;
    }
  }

  function applyCta(){
    if (!STATE.isLA) return;
    var btn = q('.quickview-product .btn-addToCart');
    if (!btn) return;

    // cache product href
    var href = getProductHref();
    if (href) STATE.lastHref = href;

    // If disabled (OOS/Unavailable), keep theme text.
    var disabled = btn.classList.contains('disabled') || btn.hasAttribute('disabled');
    if (disabled) {
      btn.classList.remove('es-qv-select-lenses');
      btn.removeAttribute('data-es-qv-label');
      return;
    }

    // Ensure label
    if (btn.textContent.trim() !== getSelectLensesText()) {
      btn.textContent = getSelectLensesText();
    }
    btn.classList.add('es-qv-select-lenses');
    btn.setAttribute('data-es-qv-label', getSelectLensesText());
    btn.setAttribute('aria-label', getSelectLensesAria());
  }

  // 1) Capture which product is being opened BEFORE quickview.js runs
  document.addEventListener('click', function(ev){
    var trigger = closest(ev.target, '.engoj_btn_quickview');
    if (!trigger) return;
    STATE.isLA = (trigger.getAttribute('data-es-la') === '1');
    STATE.lastHref = '';
    STATE.qvHandle = (trigger.getAttribute('data-id') || '').trim();
    // Record list/search scroll position BEFORE QuickView scroll-locks the page.
    try {
      sessionStorage.setItem('es_qv_open_url', (window.location.href || '').split('#')[0]);
      sessionStorage.setItem('es_qv_open_y', String(getBestScrollY()));
      sessionStorage.setItem('es_qv_open_ts', String(Date.now()));
    } catch(e) {}
    // We intentionally do NOT push history/hash here (keeps Back behavior native).
  }, true);

  // 2) When quickview is ready, update CTA (and after a short delay for safety)
  document.addEventListener('swym:qv-loaded', function(){
    if (!STATE.isLA) return;
    setTimeout(applyCta, 0);
    setTimeout(applyCta, 80);
  });

  // 3) Re-apply after option changes (quickview.js updates the button text)
  document.addEventListener('change', function(ev){
    if (!STATE.isLA) return;
    if (!closest(ev.target, '.quickview-product')) return;
    setTimeout(applyCta, 0);
    setTimeout(applyCta, 100);

    // Keep URL state in sync if user changes variants inside QV.
    if (ES_QV_HISTORY && STATE.qvHandle) {
      try { replaceQuickviewState(STATE.qvHandle, getQuickviewVariantId()); } catch(e) {}
    }
  }, true);

  // 4) Intercept click on the QuickView add-to-cart button for LA products
  document.addEventListener('click', function(ev){
    if (!STATE.isLA) return;
    var btn = closest(ev.target, '.quickview-product .btn-addToCart');
    if (!btn) return;

    // If disabled, do nothing.
    var disabled = btn.classList.contains('disabled') || btn.hasAttribute('disabled');
    if (disabled) return;

    // Stop Ajax add-to-cart
    ev.preventDefault();
    ev.stopPropagation();
    if (typeof ev.stopImmediatePropagation === 'function') ev.stopImmediatePropagation();

    // Redirect to PDP and auto-open LensAdvisor
    var href = getProductHref() || STATE.lastHref;
    var url = withOpenLA(href);
    if (url) {
      // Ensure the current QV state is recorded before leaving the page.
      if (ES_QV_HISTORY && !parseQvFromHash() && STATE.qvHandle) {
        pushQuickviewState(STATE.qvHandle);
      }
      // Remember the originating page + scroll position so Back returns in 1 press and at the same spot.
      try {
        var originUrl = (window.location.href || '').split('#')[0];
        var y0 = getBestScrollY();

        // Prefer the scroll captured BEFORE QuickView scroll-lock (more reliable).
        var qvUrl = sessionStorage.getItem('es_qv_open_url') || '';
        var qvY = parseInt(sessionStorage.getItem('es_qv_open_y') || '0', 10) || 0;
        if (qvUrl && qvUrl === originUrl && qvY > 0) y0 = qvY;

        sessionStorage.setItem('es_la_origin_url', originUrl);
        if (y0 && y0 > 0) sessionStorage.setItem('es_la_origin_y', String(y0));
        sessionStorage.setItem('es_la_origin_ts', String(Date.now()));
      } catch(e) {}
      window.location.href = url;
    }
  }, true);

})();
